import { catchError, map, Observable, of, tap, throwError } from 'rxjs';
import { ApiService } from './api.service';
import { Injectable, signal } from '@angular/core';
import { UserProfile } from '../models/user.model';
import { API_ENDPOINTS } from '@core/constants/api-endpoints.constants';
import { ApiResponse, Result, SuccessResponse } from '../models/common.model';
import { OrganizationLogoResponse } from '../models/org.model';

@Injectable({ providedIn: 'root' })
export class UserService {
  public userProfile = signal<UserProfile | null>(null);

  // private userProfileSubject = new BehaviorSubject<UserProfile | null>(null);
  // userProfile$ = this.userProfileSubject.asObservable();

  constructor(private apiService: ApiService,) {}
// upload profile image - Done
  uploadProfileImage(file: File, uid: string): Observable<Result<UserProfile>> {
    const formData = new FormData();
    formData.append('profilePicture', file);

    return this.apiService
      .putWithFormData<ApiResponse<UserProfile>>(
        `${API_ENDPOINTS.USERS.PROFILE(uid || '')}`,
        formData
      )
      .pipe(
        map((res) => ({ success: true as const, data: res.data })),
        tap((result) => {
          if (result.success) {
            console.log('Profile image uploaded:', result.data);
          }
        }),
        catchError((error) => throwError(() => this.apiService.handleApiError<UserProfile>(error)))
      );
  }

  // get profile image - Done
  getProfileImage(uid: string): Observable<Result<OrganizationLogoResponse>> {
    return this.apiService
      .get<ApiResponse<OrganizationLogoResponse>>(`${API_ENDPOINTS.USERS.PROFILE(uid)}`)
      .pipe(
        map((res) => ({ success: true as const, data: res.data })),
        tap((result) => {
          if (result.success) {
            console.log('Profile image uploaded:', result.data);
          }
        }),
        catchError((error) => throwError(() => this.apiService.handleApiError<UserProfile>(error)))
      );
  }

  // get user profile by uid - Done
  getUserProfileByUid(uid: string): Observable<Result<UserProfile>> {
    return this.apiService
      .get<SuccessResponse<UserProfile>>(`${API_ENDPOINTS.AUTH.REGISTER}/${uid}`)
      .pipe(
        map((res) => ({ success: true as const, data: res.data })),
        tap((result) => {
          if (result.success) {
            // this.userProfile.set(result.data);
            // this.userProfileSubject.next(result.data);
          } else {
            this.userProfile.set(null);
            // this.userProfileSubject.next(null);
          }
        }),
        catchError((err) => of(this.apiService.handleApiError<UserProfile>(err)))
      );
  }

  // update user profile - Done
  updateUserProfile(profile: UserProfile, uid: string): Observable<Result<UserProfile>> {
    return this.apiService
      .put<ApiResponse<UserProfile>>(`${API_ENDPOINTS.USERS.VIEW(uid)}`, profile)
      .pipe(
        map((res) => ({ success: true as const, data: res.data })),
        tap((result) => {
          // this.userProfile.set(result.data);
          // this.userProfileSubject.next(result.data);
          //this.userProfileSubject.next(result.data);
        }),
        catchError((error) => throwError(() => this.apiService.handleApiError<UserProfile>(error)))
      );
  }
}
